import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ERROR } from '../../constants/routes';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, hasRedirected: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidUpdate(prevProps, prevState) {
    const { hasError, hasRedirected } = this.state;
    if (hasError && !prevState?.hasError && !hasRedirected) {
      const { history } = this.props;
      this.setState({ hasRedirected: true });
      history.replace(`${ERROR}/500`);
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  }

  componentDidCatch(error, errorInfo) {
    console.log(`Unhandle error found ${error}, ${errorInfo}`);
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    //if sentry is initialized, capture the exception
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  profiles: state.profiles,
  buttons: state.buttons,
  screenings: state.screenings,
});

export default withRouter(connect(mapStateToProps)(ErrorBoundary));
